const configs: Record<string, GwtConfig<any>> = {};

function parseJson<D>(data: string): D {
    const json = data ? data.replace(/<!--/ig, '').replace(/-->/ig, '') : null;
    return json ? JSON.parse(json) : null;
}

export class GwtConfig<D> {
    data: D = {} as D;

    constructor(hookId: string) {
        let data;

        if (configs.hasOwnProperty(hookId)) {
            if (configs[hookId] instanceof GwtConfig) {
                return configs[hookId];
            }
            data = configs[hookId];

        } else {
            let el = document.getElementById('hook_Cfg_' + hookId);
            if (!el) {
                // возможно, конфиг нативный (без GWT)
                el = document.getElementById(hookId);
            }
            if (el) {
                try {
                    data = parseJson<D>(el.innerHTML);
                } catch (e) {
                    data = {};
                }
            }
        }

        this.setData(data as D);

        configs[hookId] = this;
    }

    setData(data: D) {
        this.data = data;
    }
}

export function applyConfig(hookId: string, cfg: GwtConfig<any>) {
    if (configs[hookId] instanceof GwtConfig) {
        configs[hookId].setData(cfg);
    } else {
        configs[hookId] = cfg;
    }
}
